import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-10 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-10 p-sm-15 p-md-20 letter-spacing" }
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger mt-1 fs-md-12"
}
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-control shadow-none fs-md-14 text-black fw-bold" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger mt-1 fs-md-12"
}
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-md-7" }
const _hoisted_16 = { class: "border border-success mb-4" }
const _hoisted_17 = { class: "table table-sm mb-0 align-middle" }
const _hoisted_18 = { class: "text-end fw-semibold" }
const _hoisted_19 = { class: "text-end fw-semibold text-success" }
const _hoisted_20 = { class: "text-end fw-semibold text-danger" }
const _hoisted_21 = { class: "table-success" }
const _hoisted_22 = { class: "text-end fw-bold" }
const _hoisted_23 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_24 = { class: "col-md-5" }
const _hoisted_25 = { class: "border border-primary mb-4" }
const _hoisted_26 = { class: "p-3" }
const _hoisted_27 = { class: "fs-5 fw-bold" }
const _hoisted_28 = {
  key: 0,
  class: "fs-md-12"
}
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "mb-2 mt-1" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Fermeture de caisse", -1)),
        _createVNode(_component_router_link, {
          to: "/OuverturesFermetures",
          class: "btn btn-primary transition border-0 lh-1 fw-medium"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
            _createElementVNode("span", { class: "position-relative" }, null, -1),
            _createTextVNode("Retour ")
          ])),
          _: 1
        })
      ]),
      _createVNode(_component_Form, {
        class: "row g-2",
        "validation-schema": _ctx.schema,
        onSubmit: _ctx.sendFermerOuvFer
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de fermeture", -1)),
                _createVNode(_component_Field, {
                  name: "dateFin",
                  type: "datetime-local",
                  max: _ctx.currentDateTime,
                  modelValue: _ctx.dateFin,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateFin) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  readonly: ""
                }, null, 8, ["max", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Personnes présentes à la fermeture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "user" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: _ctx.user,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user) = $event)),
                      options: _ctx.userOptions,
                      searchable: true,
                      mode: "tags",
                      label: "label",
                      "track-by": "value",
                      placeholder: "Sélectionner les personnes"
                    }, field), null, 16, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                }),
                (_ctx.userOptions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Aucune personne disponible. "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Caisse", -1)),
              _createElementVNode("div", _hoisted_12, " Vous êtes en train de fermer la caisse : " + _toDisplayString(_ctx.caisseNom), 1),
              (!_ctx.caisseNom)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Aucune caisse ouverte disponible."))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.rapport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", {
                      class: "py-1 px-2 fw-bold text-white",
                      style: {"background-color":"#28a745"}
                    }, [
                      _createElementVNode("span", { class: "fs-15" }, "Point de caisse (espèces)")
                    ], -1)),
                    _createElementVNode("table", _hoisted_17, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("td", null, "Fond de caisse (ouverture)", -1)),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.separateur(_ctx.rapport.fondDeCaisse)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("td", null, "+ Entrées en espèces", -1)),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.separateur(_ctx.rapport.totaux.entrees)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("td", null, "− Sorties en espèces", -1)),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.separateur(_ctx.rapport.totaux.sorties)), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_21, [
                          _cache[12] || (_cache[12] = _createElementVNode("td", { class: "fw-bold" }, "= Solde théorique", -1)),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.separateur(_ctx.rapport.soldeTheorique)) + " FCFA", 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.rapport.remboursementsAnterieurs.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.rapport.remboursementsAnterieurs.length) + " remboursement(s) concernent des ventes de sessions précédentes (" + _toDisplayString(_ctx.separateur(_ctx.totalRemboursementsAnterieurs)) + " FCFA). ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "py-1 px-2 fw-bold text-white bg-primary" }, [
                      _createElementVNode("span", { class: "fs-15" }, "Comptage physique")
                    ], -1)),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                        _createTextVNode(" Solde compté en caisse (FCFA) "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "0",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.soldeCompte) = $event)),
                        class: _normalizeClass(_ctx.soldeCompteInvalide ? 'form-control is-invalid' : 'form-control'),
                        placeholder: "Total des espèces comptées"
                      }, null, 2), [
                        [
                          _vModelText,
                          _ctx.soldeCompte,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "invalid-feedback" }, "Saisissez un montant positif ou nul", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["mt-3 p-2 text-center border", _ctx.classeEcart])
                      }, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "fs-md-13" }, "Écart (compté − théorique)", -1)),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.ecart === null ? '—' : _ctx.formatEcart(_ctx.ecart)), 1),
                        (_ctx.ecart !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.ecart === 0 ? 'La caisse est juste.' : _ctx.ecart > 0 ? 'Excédent en caisse.' : 'Manquant en caisse.'), 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                for: "observationsFin",
                class: "d-block text-black fw-semibold mb-2"
              }, "Observations", -1)),
              _createVNode(_component_Field, {
                name: "observationsFin",
                as: "textarea",
                class: "form-control fs-md-14",
                modelValue: _ctx.observationsFin,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.observationsFin) = $event)),
                placeholder: "Entrez vos observations (facultatif)"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "observationsFin",
                class: "text-danger fs-md-12"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary btn-sm top-end",
              disabled: !_ctx.caisse || !_ctx.rapport || _ctx.soldeCompteInvalide || _ctx.isSubmitting
            }, " Fermer ", 8, _hoisted_32),
            _createVNode(_component_router_link, {
              to: "/OuverturesFermetures",
              type: "button",
              class: "btn btn-danger btn-sm mx-1"
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode(" Annuler ")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"])
    ])
  ]))
}